<template>
  <span class="count-up">{{ prefix }}{{ formatted }}</span>
</template>

<script>
// Counts a number up from 0 (or from its previous value) when it appears or changes.
export default {
  name: "CountUp",
  props: {
    value: { type: [Number, String], default: 0 },
    prefix: { type: String, default: "" },
    duration: { type: Number, default: 1200 },
  },
  data() {
    return { shown: 0, frame: null };
  },
  computed: {
    formatted() {
      return Math.round(this.shown).toLocaleString("en-US");
    },
  },
  watch: {
    value() { this.animate(); },
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.frame); },
  methods: {
    animate() {
      cancelAnimationFrame(this.frame);
      const from = this.shown;
      const to = Number(this.value) || 0;
      const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce || from === to) { this.shown = to; return; }
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / this.duration);
        this.shown = from + (to - from) * (1 - Math.pow(1 - t, 3)); // ease-out cubic
        if (t < 1) this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    },
  },
};
</script>

<style scoped>
.count-up { font-variant-numeric: tabular-nums; }
</style>
